import { request } from 'root/common/request';
import apiJSON from '../../common/config/config';
import { getAppVersion } from '../util/getAppVersion';
const api = {
    /**
     * 获取banner 图列表
     *
     * @returns
     */

    async getTiShen(options = {}) {
        if (window.ZZCFL.Utils.UA.os.name != 'ios') {
            return false;
        }

        let version = getAppVersion() || '';
        if (version) {
            version = version.replace(/\./g, '');
        }
        const res = await request({
            url: apiJSON.api.getSettingBYD,
            method: 'get',
            params: { name: `app-ios-rv-${version}` },
            loadingText: '加载中，请稍等...',
            headers: {},
            ...options,
            isNeedToken: false,
        });
        return res;
    },

    async getMineSetting(options = {}) {
        const res = await request({
            url: apiJSON.api.getAdvertiseEntry,
            method: 'get',
            params: { pageTag: window.appIsTiShen ? 'mine-rv' : 'mine' },
            loadingText: '加载中，请稍等...',
            headers: {},
            ...options,
            isNeedToken: false,
        });
        return res;
    },

    isNewUser(options = {}) {
        return request({
            url: apiJSON.api.isNewUser,
            method: 'get',
            loadingText: false,
            isShowCatchErr: false,
            headers: {},
            isNeedToken: true,
            isNeedLoading: false,
            ...options,
        });
    },
    getAgentLeaderInfo(options = {}) {
        return request({
            url: apiJSON.api.getAgentLeaderInfo,
            method: 'get',
            loadingText: false,
            isShowCatchErr: false,
            headers: {},
            isNeedToken: true,
            isNeedLoading: false,
            ...options,
        });
    },
    getCpsPageAbTest(params, options = {}) {
        return request({
            url: apiJSON.api.getCpsPageAbTest,
            method: 'get',
            params,
            loadingText: false,
            isShowCatchErr: false,
            headers: {},
            isNeedToken: true,
            ...options,
        });
    },

    /**
     * 获取ztm配置
     * @param {*} params
     * @param {*} options
     */
    getZTMConfig(params, options) {
        return request({
            url: apiJSON.api.getZTMConfig,
            method: 'get',
            params,
            isNeedLoading: false,
            ...options,
        });
    },

    getCardInfo(options = {}) {
        return request({
            url: apiJSON.api.privilegePoint,
            method: 'get',
            loadingText: false,
            isShowCatchErr: false,
            headers: {},
            isNeedToken: true,
            ...options,
        });
    },
};

export default api;

// 获取返现配置
export const getFanxianConfig = data => {
    return request({
        url: apiJSON.api.getFanxianConfig,
        method: 'post',
        data,
        headers: {},
        isNeedLoading: false,
    });
};
// 获取返现配置V2
export const getFanxianConfigV2 = data => {
    return request({
        url: apiJSON.api.getFanxianConfigV2,
        method: 'post',
        data,
        headers: {},
        isNeedLoading: false,
    });
};
// 省钱宝首单激励-订单聚合页-图片
export const getSqbFirstOrderPic = () => {
    return request({
        url: apiJSON.api.getSqbFirstOrderPic,
        method: 'get',
        isNeedLoading: false,
    });
};
